import type { AggregateOrdersDataPayload, BulkViewData } from './types'
import { compareLoads } from './compare/compareLoads'
import { compareNumberValue } from './compare/compareNumberValue'
import { compareStringValue } from './compare/compareStringValue'
import { compareTags } from './compare/compareTags'
import { compareTimeWindows } from './compare/compareTimeWindows'
import { computeInitialOrderData } from './computeInitialOrderData'
import { computeOrderData } from './computeOrderData'

export function aggregateOrdersData(
  payload: AggregateOrdersDataPayload,
  formatEligibility: (eligibility: uui.domain.client.rm.Eligibility) => string,
) {
  const { orders, companiesMap, archived } = payload

  const [firstOrder, ...otherOrders] = orders

  const firstOrderData = computeOrderData({
    order: firstOrder,
    companiesMap: companiesMap,
    archived: archived,
    formatEligibility,
  })

  return otherOrders.reduce<BulkViewData>((acc, order) => {
    const orderData = computeOrderData({
      order,
      companiesMap,
      archived,
      formatEligibility,
    })

    for (const violation of orderData.violations) {
      acc.violations.add(violation)
    }

    acc.loads = compareLoads(acc.loads, orderData.loads)
    acc.eligibility = compareStringValue(acc.eligibility, orderData.eligibility)
    acc.company = compareStringValue(acc.company, orderData.company)
    acc.priority = compareNumberValue(acc.priority, orderData.priority) as BulkViewData['priority']
    acc.serviceTime = compareNumberValue(acc.serviceTime, orderData.serviceTime)
    acc.vehicleId = compareStringValue(acc.vehicleId, orderData.vehicleId)
    acc.phone = compareStringValue(acc.phone, orderData.phone)
    acc.email = compareStringValue(acc.email, orderData.email)
    acc.notes = compareStringValue(acc.notes, orderData.notes)
    acc.tagsIn = compareTags(acc.tagsIn, orderData.tagsIn)
    acc.tagsOut = compareTags(acc.tagsOut, orderData.tagsOut)
    acc.timeWindows = compareTimeWindows(acc.timeWindows, orderData.timeWindows)

    return acc
  }, computeInitialOrderData(firstOrderData))
}
